import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import {
    AssignPromotionsToChannelDocument,
    BulkAction,
    createBulkAssignToChannelAction,
    createBulkDeleteAction,
    createBulkRemoveFromChannelAction,
    DuplicateEntityDialogComponent,
    GetPromotionListQuery,
    ItemOf,
    ModalService,
    Permission,
    RemovePromotionsFromChannelDocument,
} from '@vendure/admin-ui/core';
import { gql } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { SpinPromosListComponent } from './spin-promos-list.component';

export const deleteSpinPromosBulkAction = createBulkDeleteAction<ItemOf<GetPromotionListQuery, 'promotions'>>(
    {
        location: 'spin-promos-list',
        requiresPermission: 'SpinRewardsControl',
        getItemName: item => item.name,
        bulkDelete: (dataService, ids) =>
            dataService.promotion.deletePromotions(ids).pipe(map(res => res.deletePromotions)),
    },
);

export const assignPromotionsToChannelBulkAction = createBulkAssignToChannelAction<
    ItemOf<GetPromotionListQuery, 'promotions'>
>({
    location: 'spin-promos-list',
    requiresPermission: 'SpinRewardsControl',
    getItemName: item => item.name,
    bulkAssignToChannel: (dataService, promotionIds, channelIds) => {
        return channelIds.map(channelId =>
            dataService
                .mutate(AssignPromotionsToChannelDocument, {
                    input: {
                        channelId,
                        promotionIds,
                    },
                })
                .pipe(map(res => res.assignPromotionsToChannel)),
        );
    },
});

export const removePromotionsFromChannelBulkAction = createBulkRemoveFromChannelAction<
    ItemOf<GetPromotionListQuery, 'promotions'>
>({
    location: 'spin-promos-list',
    requiresPermission: 'SpinRewardsControl',
    getItemName: item => item.name,
    bulkRemoveFromChannel: (dataService, promotionIds, channelId) =>
        dataService
            .mutate(RemovePromotionsFromChannelDocument, {
                input: {
                    channelId,
                    promotionIds,
                },
            })
            .pipe(map(res => res.removePromotionsFromChannel)),
});

export const duplicatePromotionsBulkAction: BulkAction<
    ItemOf<GetPromotionListQuery, 'promotions'>,
    SpinPromosListComponent
> = {
    location: 'spin-promos-list',
    label: _('common.duplicate'),
    requiresPermission: 'SpinRewardsControl',
    icon: 'copy',
    onClick: ({ injector, selection, hostComponent, clearSelection }) => {
        const modalService = injector.get(ModalService);
        modalService
            .fromComponent(DuplicateEntityDialogComponent<ItemOf<GetPromotionListQuery, 'promotions'>>, {
                locals: {
                    entities: selection,
                    entityName: 'Promotion',
                    title: _('marketing.duplicate-promotions'),
                    getEntityName: entity => entity.name,
                },
            })
            .subscribe(result => {
                if (result) {
                    clearSelection();
                    hostComponent.refresh();
                }
            });
    },
};
